import { render } from "./FacetesFilter2.vue?vue&type=template&id=5cde386a&scoped=true"
import script from "./FacetesFilter2.vue?vue&type=script&lang=js"
export * from "./FacetesFilter2.vue?vue&type=script&lang=js"

import "./FacetesFilter2.vue?vue&type=style&index=0&id=5cde386a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cde386a"]])

export default __exports__